(function () {
  'use strict';
  if (window.healthyKidsBirthday) return;
  window.healthyKidsBirthday = true;
  var lifetime = 2 * 60 * 60 * 1000;

  function init(scope) {
    scope.querySelectorAll('.kids-birthday-download').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      var form = root.closest('form');
      var link = root.querySelector('[data-kids-pdf]');
      var status = root.querySelector('[data-pdf-status]');
      var retry = root.querySelector('[data-pdf-retry]');
      var restart = root.querySelector('[data-pdf-restart]');
      var submit = root.querySelector('[data-pdf-submit]');
      var editor = window.Shopify && window.Shopify.designMode;
      var key = 'healthy-italia:pdf-request:v1:' + root.dataset.eventType + ':' + location.pathname;
      var draft;
      try {
        draft = JSON.parse(sessionStorage.getItem(key));
        if (!draft || Date.now() - draft.savedAt >= lifetime) {
          sessionStorage.removeItem(key);
          draft = null;
        }
      } catch (error) { draft = null; }
      if (submit) submit.disabled = false;
      form.addEventListener('submit', function (event) {
        if (editor) { event.preventDefault(); return; }
        var details = {};
        ['name', 'email', 'phone'].forEach(function (name) {
          var input = form.elements.namedItem('contact[' + name + ']');
          input.value = input.value.trim();
          details[name] = input.value;
        });
        if (!form.reportValidity()) { event.preventDefault(); return; }
        try {
          // One key per completed form, reused across API retries after Shopify's confirmation.
          draft = {token: crypto.randomUUID(), savedAt: Date.now(), contact: details};
          sessionStorage.setItem(key, JSON.stringify(draft));
        } catch (error) {
          event.preventDefault();
          status.textContent = 'Please allow browser storage to send your details and download the PDF.';
        }
        // Keep Shopify's native submission and spam challenge.
      });
      if (!link || editor) return;

      var saving = false;
      async function save() {
        if (saving) return;
        if (!draft || (!draft.requestId && !draft.contact)) {
          status.textContent = 'Your details are no longer available in this browser. Please enter them again to download the PDF.';
          restart.hidden = false;
          return;
        }
        saving = true;
        retry.hidden = true;
        status.textContent = 'Saving your details…';
        try {
          if (!draft.requestId) {
            var base = new URL(root.dataset.apiBase);
            if (base.protocol !== 'https:') throw new Error('Invalid API URL');
            var response = await fetch(base.href.replace(/\/$/, '') + '/api/public/pdf-requests', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(Object.assign({}, draft.contact, {
                token: draft.token, eventType: root.dataset.eventType,
                pagePath: location.pathname, pdfUrl: link.href
              })), signal: AbortSignal.timeout(15000)
            });
            if (!response.ok) throw new Error('Save failed');
            var result = await response.json();
            if (!result.id) throw new Error('Save not confirmed');
            draft.requestId = result.id;
            delete draft.contact;
            // The API has saved the lead even if the browser can no longer persist this marker.
            try { sessionStorage.setItem(key, JSON.stringify(draft)); } catch (error) { /* Retry remains idempotent. */ }
          }
          link.hidden = false;
          status.textContent = 'Your details have been saved. Your PDF is ready.';
          download();
        } catch (error) {
          status.textContent = 'We couldn’t save your details. Please retry to download your PDF.';
          retry.hidden = false;
        } finally { saving = false; }
      }
      // CDN links may ignore `download`; use a blob and keep a manual link as fallback.
      async function download(event) {
        if (event) event.preventDefault();
        if (!draft.requestId || root.dataset.downloading) return;
        root.dataset.downloading = 'true';
        try {
          var response = await fetch(link.href, {signal: AbortSignal.timeout(30000)});
          if (!response.ok) throw new Error('PDF unavailable');
          var blob = await response.blob();
          var url = URL.createObjectURL(blob);
          var anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = link.download;
          document.body.appendChild(anchor);
          anchor.click();
          anchor.remove();
          setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
        } catch (error) {
          link.removeEventListener('click', download);
          status.textContent = 'Your details have been saved. Select Download PDF to open the document.';
        } finally { delete root.dataset.downloading; }
      }
      retry.addEventListener('click', save);
      link.addEventListener('click', download);
      save();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
